<template>
  <d2-container>
    <el-button
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="getAdd"
      v-permission:function="['secretLanguageManger:btn_add']"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="secretLanguageList"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="标签名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="封面图" width="200">
        <template slot-scope="scope">
          <span>
            <el-popover placement="left" trigger="click" width="300">
              <img :src="scope.row.coverImg" width="300px" />
              <img
                slot="reference"
                :src="scope.row.coverImg"
                :alt="scope.row.coverImg"
                style="max-height: 70px;max-width: 70px; padding: 5px"
              />
            </el-popover>
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="背景图" width="200">
        <template slot-scope="scope">
          <span>
            <el-popover placement="left" trigger="click" width="300">
              <img :src="scope.row.backImg" width="300px" />
              <img
                slot="reference"
                :src="scope.row.backImg"
                :alt="scope.row.backImg"
                style="max-height: 70px;max-width: 70px; padding: 5px"
              />
            </el-popover>
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="420">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="editCard(scope.row.id)"
            style="margin-top: 10px;"
            v-permission:function="['secretLanguageManger:btn_edit']"
          >编辑</el-button>
          <el-button
            size="small"
            type="danger"
            @click="delCard(scope.row.id)"
            v-permission:function="['secretLanguageManger:btn_del']"
            style="margin-top: 10px;"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form" label-width="170px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="名称"></el-input>
        </el-form-item>
         <el-form-item label="排序" prop="sort">
          <el-input v-model="form.sort" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
        <el-radio-group v-model="form.type">
          <el-radio :label="0">正常</el-radio>
          <el-radio :label="1">七夕</el-radio>
        </el-radio-group>
      </el-form-item>
        <el-form-item label="封面图" required prop="coverImg2">
          <uploadImg v-model="form.coverImg2" :max="1" :text="['图片大小500kb以内']"></uploadImg>
        </el-form-item>
        <el-form-item label="背景图" required prop="backImg2">
          <uploadImg v-model="form.backImg2" :max="1" :text="['图片大小500kb以内']"></uploadImg>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button v-if="dialogStatus=='create'" type="primary" @click="create('form')">确 定</el-button>
        <el-button v-else type="primary" @click="update('form')">确 定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import uploadImg from '@/components/uploadImage/index.vue'
import {
  getSenAdd,
  getSenEdit,
  getSenList,
  getSenInfo,
  getSenDel
} from '@/api/demo/secretLanguage/index'
export default {
  name: 'secretLanguageManger',
  computed: {
    ...mapGetters(['elements'])
  },
  components: {
    uploadImg
  },
  data () {
    return {
      tableKey: 0,
      secretLanguageList: [],
      secretLanguageManger_btn_add: false,
      secretLanguageManger_btn_edit: false,
      secretLanguageManger_btn_del: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      dialogFormVisible: false,
      id: '',
      form: {
        backImg: '',
        backImg2: [],
        coverImg: '',
        coverImg2: [],
        sort: '',
        type: 0,
        name: '' // 名称
      },
      listLoading: false,
      rules: {
        name: [
          {
            required: true,
            message: '名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        coverImg2: [
          {
            required: true,
            message: '请上传封面图',
            trigger: 'blur'
          }
        ],
        backImg2: [
          {
            required: true,
            message: '请上传背景图',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getSearch()
  },
  methods: {
    getSearch () {
      let that = this
      let data = {
        currentPage: 1,
        pageSize: 50
      }
      getSenList(data).then(
        res => {
          that.listLoading = true
          that.secretLanguageList = res.records
          that.listLoading = false
        },
        err => {
          console.log('res', err)
        }
      )
    },
    getAdd () {
      let that = this
      that.dialogStatus = 'create'
      that.dialogFormVisible = true
    },
    cancel () {
      let that = this
      that.dialogFormVisible = false
    },
    create (form) {
      let that = this
      // that.form.coverImg = that.form.coverImg2.join("");
      // that.form.backImg = that.form.backImg2.join("");
      const set = that.$refs
      set[form].validate(valid => {
        if (valid) {
          getSenAdd(that.form).then(res => {
            that.$message({
              message: '新增成功',
              type: 'success',
              center: true
            })
            that.getSearch()
            that.dialogFormVisible = false
          })
        }
      })
    },
    editCard (id) {
      let that = this
      that.dialogStatus = 'update'
      that.id = id
      getSenInfo(id).then(res => {
        that.dialogFormVisible = true
        // that.form.backImg2 = res.backImg.split(",");
        // that.form.coverImg2 = res.coverImg.split(",");
        that.form.name = res.name
      })
    },
    update (form) {
      let that = this
      that.form.coverImg = that.form.coverImg2.join(',')
      that.form.backImg = that.form.backImg2.join(',')
      const set = that.$refs
      set[form].validate(valid => {
        if (valid) {
          getSenEdit(that.id, that.form).then(res => {
            that.$message({
              message: '编辑成功',
              type: 'success',
              center: true
            })
            that.getSearch()
            that.dialogFormVisible = false
          })
        }
      })
    },
    // 删除
    delCard (id) {
      let that = this
      this.$confirm('此操作将删除该主题, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          getSenDel(id).then(res => {
            that.$message({
              message: '删除成功',
              type: 'success',
              center: true
            })
            that.getSearch()
          })
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style scoped>
</style>
